import { ThemeProvider, createTheme } from '@mui/material/styles'

// ** Theme
import themeOptions from './ThemeOptions'

// ** Global Styles

const ThemeComponent = (props) => {
  // ** Props
  const { children } = props

  // ** Pass merged ThemeOptions (of core and user) to createTheme function
  let theme = createTheme(themeOptions({}, 'light'))

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default ThemeComponent
